import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMerge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 7,
			width: 12,
			height: 12,
			rx: 1,
			stroke: "currentColor",
			strokeOpacity: 1,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 7,
			width: 6,
			height: 6,
			rx: 1,
			fill: "currentColor",
			fillOpacity: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 1,
			width: 12,
			height: 12,
			rx: 1,
			fill: "currentColor",
			fillOpacity: 1,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgMerge;
